export default __webpack_public_path__ + "static/media/gauge_70.97e85e53.svg";